import React from 'react';
import smoothscroll from 'smoothscroll-polyfill';

import Header from './Header';
import Menu from './Menu';
import Loading from './Loading';
import InstallPWAButton from '~/components/InstallPWAButton';

interface AppProps {
  loading: boolean;
  showHeader?: boolean;
}

smoothscroll.polyfill();

const App: React.FC<AppProps> = ({ loading, showHeader = true, children }) => {
  return (
    <>
      <div>
        <Loading show={loading} />

        <Header show={showHeader} />

        <main className="h-100 has-footer">
          <div className="main-container container">{children}</div>
        </main>

        <Menu />

        <InstallPWAButton />
      </div>

      {/* <Helmet>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5.0/font/bootstrap-icons.css"
        />
        <link
          href="assets_front/vendor/nouislider/nouislider.min.css"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          href="assets_front/vendor/swiperjs-6.6.2/swiper-bundle.min.css"
        />
        <link href="assets_front/css/style.css" rel="stylesheet" />

        <link href="assets_front/css/custom.css" rel="stylesheet" />

        <link
          rel="stylesheet"
          href="assets_front/vendor/swiperjs-6.6.2/swiper-bundle.min.css"
        />

        <script src="assets_front/vendor/swiperjs-6.6.2/swiper-bundle.min.js" />
      </Helmet> */}
    </>
  );
};

export default App;
